var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMusicDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 20.752c0 .64-.61 1.15-1.23.98-2.4-.68-3.77-2.64-3.77-5.54v-8.38c0-2.9 1.37-4.86 3.77-5.54.62-.17 1.23.33 1.23.98v17.5zM11.79 15.051c0 .37.31.68.68.68.38 0 .69-.31.69-.68a.69.69 0 0 0-.69-.68.68.68 0 0 0-.68.68zM16.828 14.14c0 .38.31.68.69.68.38 0 .69-.31.69-.68 0-.37-.31-.69-.69-.69-.38 0-.69.31-.69.69z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h6.69C19.4 22 22 19.4 22 16.19V7.81C22 4.6 19.4 2 16.19 2H9.5zm10.1 12.14c0 .01-.01.02-.01.03a2.074 2.074 0 0 1-2.07 2.04c-1.14 0-2.07-.93-2.07-2.07 0-1.14.93-2.07 2.07-2.07.24 0 .47.05.69.13v-1.55l-3.67 1v3.42c0 .01-.01.02-.01.03a2.074 2.074 0 0 1-2.07 2.04c-1.14 0-2.07-.93-2.07-2.07 0-1.14.93-2.07 2.07-2.07.24 0 .47.05.69.13V9.5c0-.86.53-1.56 1.36-1.77l2.75-.76c.86-.23 1.39 0 1.69.23.43.33.64.85.64 1.55v.99h.01v4.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMusicDashboard);
export default __webpack_public_path__ + "static/media/vuesax-bold-music-dashboard.3c2faab6065c05443685f3312fd69465.svg";
export { ForwardRef as ReactComponent };